import React from 'react';
import { oneOfType, number, string, array, bool, func } from 'prop-types';
import { get, map, filter, head, includes, compact } from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';
import { Table, Tooltip, Modal, Tag } from 'antd';
import TableContainer from '../../shared/Table';
import { generateTraceabilityUtil, userModuleTypes, validations } from '../../../utils/misc';
import { StatusTag, TableCount, Text, Icon, IconContainer, Row, Button, HasPermissions, FlexContainer } from '../../common';
import Mutation from '../../graphql/Mutation';
import DELETE_USER from '../../../queries/DELETE_USER';
/**
 *
  Definition from back
 */

class UsersTable extends React.Component {
    static propTypes = {
        data: array,
        loading: bool,
        onUserClicked: func,
        total: oneOfType([number, string]),
        onCompleted: func
    }

    state = {
        visible: false,
        selectedUserToDelete: null
    }

    _toggleModal = () => this.setState(({ visible }) => ({ visible: !visible, selectedUserToDelete: null }))

    handleCancel = () => this._toggleModal()

    deleteUserModal = () => {
        const { visible, selectedUserToDelete } = this.state;
        if (!visible && !selectedUserToDelete) return null;
        return (
            <Modal
                closable={false}
                title={null}
                visible={visible}
                footer={null}
            >
                <Mutation
                    mutation={DELETE_USER}
                    refetchQueries={['getUsersFeed']}
                    onCompleted={() => window.location.reload()}
                    onError={
                        <FlexContainer margin={30} align='center' direction='column'>
                            <IconContainer color='#f38630'>
                                <Icon name='trash' color='#ffffff' size={46.8} />
                            </IconContainer>
                            <FlexContainer mY={30} direction='column' align='center'>
                                <Row justify='center'>
                                    <Text text='Error al intentar eliminar el usuario' />
                                </Row>
                            </FlexContainer>
                            <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                                <Button
                                    text='Cerrar'
                                    style={{ width: '100px' }}
                                    onClick={this.handleCancel}
                                />
                            </FlexContainer>
                        </FlexContainer>
                    }
                >
                    {({ data, loading, updateFn }) => (
                        <FlexContainer margin={30} align='center' direction='column'>
                            <IconContainer color='#f38630'>
                                <Icon name='trash' color='#ffffff' size={46.8} />
                            </IconContainer>
                            <FlexContainer mY={30} direction='column' align='center'>
                                <Row justify='center'>
                                    <Text
                                        text={`Eliminarás el usuario de ${get(selectedUserToDelete, 'firstName', 'Nombre')} ${get(selectedUserToDelete, 'lastName', 'Apellido')},\u00a0`}
                                    />
                                    <Text strong text={get(selectedUserToDelete, 'email', 'nombre.apellido@dominio.cl')} />
                                </Row>
                                <Row>
                                    <Text centered text='¿Estás seguro? Esta acción es permanente y no se podrá reversar.' />
                                </Row>
                            </FlexContainer>
                            <FlexContainer justify='flex-end' style={{ width: '100%' }}>
                                <Button
                                    link
                                    text='btn.action.cancel'
                                    style={{ width: '100px' }}
                                    onClick={this.handleCancel}
                                />
                                <Button
                                    disabled={loading}
                                    loading={loading}
                                    text='btn.action.confirm'
                                    style={{ width: '100px' }}
                                    onClick={() =>
                                        updateFn({
                                            variables: { email: get(selectedUserToDelete, 'email', 'nombre.apellido@dominio.cl') }
                                        }).then(async () => {
                                            const { client } = this.props;
                                            await generateTraceabilityUtil(client, { actionId: 2 });
                                            this.handleCancel();
                                        })
                                    }
                                />
                            </FlexContainer>
                        </FlexContainer>
                    )}
                </Mutation>
            </Modal>
        );
    }

    columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: 50,
            render: (text, item, index) => {
                const { permission } = this.props;
                return (
                    <HasPermissions
                        to={[`${permission}-page:detail`]}
                        otherwise={
                            <div className='with-fb'>
                                <div className='text'>{text}</div>
                            </div>
                        }
                    >
                        <div className='with-fb'>
                            <a onClick={() => this.props.onUserClicked(item, index)}>
                                <div className='text'>{text}</div>
                            </a>
                        </div>
                    </HasPermissions>
                );
            }
        },
        {
            title: 'Nombre',
            dataIndex: 'firstName',
            key: 'firstName'
        },
        {
            title: 'Apellido',
            dataIndex: 'lastName',
            key: 'lastName'
        },
        {
            title: 'RUT',
            dataIndex: 'document',
            key: 'document',
            render: (value) => validations.document.format(value)
        },
        {
            title: 'Estado',
            dataIndex: 'statusUser',
            key: 'statusUser',
            render: (value) => {
                return <StatusTag tagType={value === '1' ? 'unavailable' : 'available'} status={value === '1' ? 'Inactivo' : 'Activo'} />
            }
        },
        (includes([userModuleTypes[1]], this.props.userModuleType) && {
            title: 'Splitero',
            dataIndex: 'splitUser',
            key: 'splitUser',
            render: (value) => {
                return <StatusTag tagType={value === '1' ? 'unavailable' : 'available'} status={value === 1 ? 'Si' : 'No'} />;
            }
        }),
        {
            title: 'Perfil',
            dataIndex: 'profiles',
            key: 'profiles',
            render: profiles => (
                <>
                  {profiles !== null ? profiles.slice(0,3).map(profile => {
                    return (
                    <>
                        {
                            profile !== undefined ?
                                <Tag key={profile} style={{marginBottom:"3px"}}>
                                    {profile}
                                </Tag> 
                            : ""
                        }
                    </> 
                    );
                  }) : ""}

                  { profiles !== null && profiles.length > 3 ? <span>...</span> : "" } 
                </>  
            )
        },
        {
            title: 'Tipo',
            dataIndex: 'pickerType',
            key: 'pickerType'
        },
        {
            title: 'Tienda',
            dataIndex: 'salesChannel.name',
            key: 'salesChannel.name'
        },
        {
            title: 'Creado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (value) => moment(value).format('DD/MM/YYYY')
        },
        {
            title: 'Actualizado',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            render: (value) => moment(value).format('DD/MM/YYYY')
        },
        {
            title: null,
            dataIndex: 'id',
            key: 'delete',
            render: (value, item) => {
                const { permission, userModuleType } = this.props;
                if (includes([userModuleTypes[1], userModuleTypes[3]], userModuleType)) return null;
                return (
                    <HasPermissions to={[`${permission}-page:delete`]}>
                        <Tooltip placement='left' title={<Text text='Eliminar usuario' color='white' />}>
                            <a onClick={() => this.setState({ selectedUserToDelete: item }, () => this.setState({ visible: true }))}>
                                <Icon name='trash' color='black' size='11' />
                            </a>
                        </Tooltip>
                    </HasPermissions>
                );
            }
        }
    ];

    render () {
        const { data, loading, total, groups, ...props } = this.props;
        const users = map(data, (user) => {
            const alias = map(get(user, 'profiles'), (profile) => get(head(filter(groups, { id: profile })), 'alias'));
            return { ...user, profiles: alias };
        });
        return (
            <TableContainer {...props}>
                {({ onRow }) => (
                    <>
                        <TableCount count={total} />
                        <Table
                            rowKey={({ email }) => email}
                            loading={loading}
                            lassName='bo-table'
                            size='small'
                            columns={compact(this.columns)}
                            dataSource={users}
                            pagination={false}
                            onRow={(record, rowIndex) => onRow(record, rowIndex)}
                        />
                        { this.deleteUserModal() }
                    </>
                )}
            </TableContainer>
        );
    }
}

export default withApollo(UsersTable);
